module.exports = __webpack_public_path__ + "img/approve-dm.3dbe2677.svg";